import { z } from "zod";

export const addressFormSchema = z.object({
  recipientName: z.string().optional(),
  company: z.string().optional(),
  street: z.string().min(1, "masterdata:StreetIsRequired"),
  houseNumber: z.string().min(1, "masterdata:HouseNumberIsRequired"),
  houseExtension: z.string().optional(),
  postalCode: z.string().min(1, "masterdata:PostalCodeIsRequired"),
  city: z.string().min(1, "masterdata:CityIsRequired"),
  country_code: z.string().min(1, "masterdata:CountryCodeIsRequired"),
  latitude: z.string().min(1, "masterdata:LatitudeIsRequired"),
  longitude: z.string().min(1, "masterdata:LongitudeIsRequired"),
});

export type AddressFormValues = z.infer<typeof addressFormSchema>;

export const addressFormDefaultValues: AddressFormValues = {
  recipientName: "",
  company: "",
  street: "",
  houseNumber: "",
  houseExtension: "",
  postalCode: "",
  city: "",
  country_code: "",
  latitude: "",
  longitude: "",
};
